export const SPACING = ['default', 'dense']
export const DIRECTION = ['left', 'right']
export const COLUMNS_WIDTH = ['default', 'auto', 'equal']
export default {
  SPACING,
  DIRECTION,
  COLUMNS_WIDTH
}
